export const monikaKruszyna = {
    'meta': {
        'title': 'Psycholog, psychoterapeuta Monika Kruszyna • Centrum COLLIGO',
        'description': 'Jestem psychologiem i psychoterapeutą poznawczo-behawioralnym w trakcie czteroletniego kursu realizowanego w Szkole Centrum CBT-EDU w Warszawie, akredytowanej przez Polskie Towarzystwo Terapii Poznawczo-Behawioralnej, którego jestem członkiem.'
    },
    'url': {
        'address': '/torun/zespol/psycholog-psychoterapeuta-monika-kruszyna/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/monika-kruszyna.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psycholog, psychoterapeuta Monika Kruszyna • Centrum COLLIGO'
        }
    }
}